package com.crowpay.views.dialogs

import com.crowpay.Credit
import com.crowpay.Project
import com.crowpay.sdk.notNullSession
import com.crowpay.utils.renderDollars
import com.crowpay.views.components.field2
import com.crowpay.views.components.requiredField
import com.crowpay.views.screens.common.secondDialog
import com.crowpay.views.theming.primaryButton
import com.crowpay.views.theming.smallBody
import com.crowpay.views.theming.specCenteredText
import com.lightningkite.UUID
import com.lightningkite.kiteui.models.KeyboardHints
import com.lightningkite.kiteui.navigation.dialogScreenNavigator
import com.lightningkite.kiteui.reactive.Property
import com.lightningkite.kiteui.reactive.bind
import com.lightningkite.kiteui.reactive.invoke
import com.lightningkite.kiteui.views.ViewModifiable
import com.lightningkite.kiteui.views.ViewWriter
import com.lightningkite.kiteui.views.centered
import com.lightningkite.kiteui.views.compact
import com.lightningkite.kiteui.views.direct.button
import com.lightningkite.kiteui.views.direct.col
import com.lightningkite.kiteui.views.direct.numberInput
import com.lightningkite.kiteui.views.direct.onClick
import com.lightningkite.kiteui.views.direct.row
import com.lightningkite.kiteui.views.expanding

class AddProjectCreditDialog(val project: Project) : BaseTextInputDialog(
    header = "Project Credit",
    message = "Enter credit to be issued for project. Credit will be allocated proportionally across all work items.",
    confirmationText = "Issue Credit",
    hint = "Reason for giving this credit (optional)"
) {
    val credit = Property<Double?>(null)

    override suspend fun ViewWriter.submit(confirmed: Boolean) {
        if (confirmed) {
            secondDialog.value = GenericConfirmationDialog(
                "Issue Credit?",
                "Confirm that you want to issue this credit to the homeowner. This will lower the price of the project and cannot be undone.",
                confirmationText = "Issue Credit",
                dismiss = { secondDialog.value = null }
            ) {
                if (it) {
                    notNullSession().nonCached.project.addProjectCredit(project._id, Credit(credit.value?.toLong() ?: return@GenericConfirmationDialog, reason = userMessage.value))
                    dialogScreenNavigator.dismiss()
                }
            }
        }
        else dialogScreenNavigator.dismiss()
    }

    override fun ViewWriter.submitButton(): ViewModifiable =
        primaryButton - button {
            ::enabled { credit().let { it != null && it > 0 && it <= project.remainingFunds } }
            specCenteredText(confirmationText)
            onClick(confirmationText) {
                submit(true)
            }
        }


    override fun ViewWriter.render2(): ViewModifiable = dialogCol {
        header()
        message()

        col {
            requiredField("Amount") {
                compact - row {
                    centered - smallBody("$")
                    expanding - numberInput {
                        hint = "Maximum ${project.remainingFunds.renderDollars()}"
                        keyboardHints = KeyboardHints.integer
                        content bind credit
                    }
                }
            }

            textInput()
        }

        actionBar()
    }
}